'use strict';

var Json_decode = require("@glennsl/bs-json/lib/js/src/Json_decode.js");

function projectile(json) {
  var name = Json_decode.field("Name", Json_decode.string, json);
  var imageName = name.replace(/ /g, "_");
  return {
          banned: Json_decode.field("Banned", Json_decode.bool, json),
          damageRatio: Json_decode.field("DamageRatio", Json_decode.$$float, json),
          maxDamage: Json_decode.field("MaxDamage", Json_decode.$$int, json),
          minDamage: Json_decode.field("MinDamage", Json_decode.$$int, json),
          name: name,
          image: "https://pvpmanager.dark-gaming.com/img/" + imageName + ".png",
          netId: Json_decode.field("NetID", Json_decode.$$int, json),
          velocityRatio: Json_decode.field("VelocityRatio", Json_decode.$$float, json)
        };
}

var Decode = {
  projectile: projectile
};

exports.Decode = Decode;
/* No side effect */
